import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAnalytics from "vue-analytics";
import Paginate from 'vuejs-paginate';
import VueI18n from "vue-i18n";
import { data } from "./assets/lang/index";
import VueCookies from 'vue-cookies'
import "./registerServiceWorker";

/* cssファイル読み込み */
import "./assets/css/iv2-theme-a-component.css";

Vue.config.productionTip = false;
Vue.use(VueCookies)
Vue.component('paginate', Paginate);

/* axiosのbaseURL設定 */
Vue.use(VueAxios, axios);
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_END_POINT + process.env.VUE_APP_SITE_ID;

axios.get("/settings").then((response) => {
    const ogp = response.data.response.sns;
    const name = response.data.response.organization.name;
    // const analytics = response.data.response.analytics;
    const onesignal = response.data.response.onesignal;
    
    // if (analytics.is_use == 1) {
    //     Vue.use(VueAnalytics, {
    //         id () {
    //             return analytics.tracking_id;
    //         }
    //     });
    // }

    /* One Signalの設定 */
    if(onesignal.app_id !== null) {
        var OneSignal = window.OneSignal || [];
        OneSignal.push(function() {
            OneSignal.init({
                appId: onesignal.app_id,
                safari_web_id: onesignal.safari_web_id,
            });
        });
    }
    
    /* meta、OGPの設定 */
    document
        .querySelector("meta[property='og:url']")
        .setAttribute("content", location.href);
    document
        .querySelector("meta[property='og:site_name']")
        .setAttribute("content", name);
    document
        .querySelector("meta[property='og:image']")
        .setAttribute("content", ogp.ogp_image);
    document
        .querySelector("meta[name='twitter:site']")
        .setAttribute("content", "@" + ogp.twitter_id);

});

/* service workerの登録 */
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/" })
    // .then(function(reg) {
    //     console.log("登録に成功しました。 Scope は " + reg.scope);
    // })
    // .catch(function(error) {
    //     console.log("登録に失敗しました。" + error);
    // });
}

/* languageファイルの設定 */
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: "ja",
    messages: data,
});

/* Google Analyticsの設定 */
Vue.use(VueAnalytics, {
    id: axios.get('/settings').then((response) => {
        return response.data.response.analytics.tracking_id;
    }),
});


new Vue({
    router,
    render: (h) => h(App),
    i18n: i18n,
}).$mount("#app");
